import {
  DialogModalDS,
  ButtonDS,
  EmailOutlined,
  TextsmsOutlined,
  Spacer,
  TextCapitalized,
} from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { PublicTransactionsPropsType } from "../transactionsAPI";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";

export const SendSmsModal = (props: {
  transaction: PublicTransactionsPropsType;
  isModalOpen: boolean;
  onCloseModal: () => void;
  sendSmsAction: (props: {
    driverPhone: string;
    driverName: string;
    transactionUuid: string;
  }) => void;
}) => {
  const { t } = useTranslation();

  return (
    <DialogModalDS
      visible={props.isModalOpen}
      onClose={props.onCloseModal}
      bottomButtons={{
        leftButton: (
          <ButtonDS
            text={t("transactions.sendSms.modal.cancel")}
            format={"fill"}
            buttonType={"secondary"}
            onClick={() => {
              props.onCloseModal();
            }}
          />
        ),
        rightButton: (
          <ButtonDS
            text={t("transactions.sendSms.modal.send")}
            format={"fill"}
            buttonType={"primary"}
            rightIcon={<EmailOutlined />}
            disabled={!props.transaction.driverName}
            onClick={() => {
              props.transaction.driverPhone &&
                props.sendSmsAction({
                  driverPhone: props.transaction.driverPhone,
                  driverName: props.transaction.driverName ?? "",
                  transactionUuid: props.transaction.uuid,
                });
              props.onCloseModal();
            }}
          />
        ),
      }}
    >
      <StyledSmsModal>
        <StyledIcon>
          <TextsmsOutlined />
        </StyledIcon>
        <Spacer y={0.5} />
        <StyledSmsModalTitle>
          <TextCapitalized>
            {t("transactions.sendSms.modal.title")}
          </TextCapitalized>
        </StyledSmsModalTitle>
        <Spacer y={0.625} />
        <TextCapitalized>
          <div>{t("transactions.sendSms.modal.content")}</div>
        </TextCapitalized>
      </StyledSmsModal>
    </DialogModalDS>
  );
};

const StyledSmsModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors["colors/text/darkGrey"]};
  ${typographies["Body/S"]};
  text-align: center;
`;

const StyledIcon = styled.div`
  & svg {
    width: 4.25rem;
    height: 4.25rem;
    fill: ${colors["colors/system/informative/informative_normal"]};
  }
  border: 0.0625rem solid ${colors["colors/borders/cards/cards"]};
  border-radius: 0.6875rem;
  padding: 0.5rem;
`;
const StyledSmsModalTitle = styled.div`
  ${typographies["Header/H3"]}
  color: ${colors["colors/text/black"]};
`;
